import type { Node_Type, RichContent, TextStyle_TextAlignment } from './../ricos-schema/legacy/wix/rich_content/v1/index.js';

import * as browser from './browser.js';

// Components
export { default as RicosPortal } from './Components/RicosPortal.js';
export { default as ToolbarButton } from './Components/ToolbarButton.js';

//Utils
export {
  BUTTON_TYPES,
  FORMATTING_BUTTONS,
  INSERT_PLUGIN_BUTTONS,
  RICOS_TIPTAP_EDITOR_DATA_HOOK,
  TOOLBARS,
} from './consts.js';
export { isiOS } from './Utils/isiOS.js';
export { isTextSelection } from './Utils/tiptap/isTextSelection.js';

import uuid from 'uuid';

export const getEmptyContent: () => RichContent = () => ({
  nodes: [
    {
      type: 'PARAGRAPH' as Node_Type,
      id: 'foo',
      nodes: [],
      paragraphData: {
        textStyle: {
          textAlignment: 'AUTO' as TextStyle_TextAlignment,
        },
        indentation: 0,
      },
    },
  ],
  metadata: {
    version: 1,
    createdTimestamp: '2022-12-19T17:56:18.279Z' as unknown as Date,
    updatedTimestamp: '2022-12-19T17:56:18.279Z' as unknown as Date,
    id: uuid.v4(),
  },
  documentStyle: {},
});

export { browser };
